import Roles from '@/auth/roles';
import FieldManagerForm from './field-manager-form';
import FieldManagerList from './field-manager-list';
import FieldManagerHistoryFull from './field-manager-history/field-manager-history-full/field-manager-history-full';
import FieldManagerHistorySingle from './field-manager-history/field-manager-history-single/field-manager-history-single';
import FieldManagerShow from './field-manager-show';

const roles = Roles.values;

export default [
  {
    name: 'fieldManagerList',
    path: 'field-manager',
    component: FieldManagerList,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.managerViewer.id,
        roles.managerEditor.id
      ]
    }
  },
  {
    name: 'fieldManagerNew',
    path: 'field-manager/new',
    component: FieldManagerForm,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.managerEditor.id
      ]
    }
  },
  {
    name: 'fieldManagerEdit',
    path: 'field-manager/:id/edit',
    component: FieldManagerForm,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.managerEditor.id
      ]
    }
  },
  {
    name: 'fieldManagerHistorySingle',
    path: 'field-manager/:id/history',
    component: FieldManagerHistorySingle,
    props: true,
    meta: {
      auth: true,
      roles: [roles.owner.id, roles.activityViewer.id]
    }
  },
  {
    name: 'fieldManagerHistoryFull',
    path: 'field-manager/history',
    component: FieldManagerHistoryFull,
    meta: {
      auth: true,
      roles: [roles.owner.id, roles.activityViewer.id]
    }
  },
  {
    name: 'fieldManagerShow',
    path: 'field-manager/:id',
    component: FieldManagerShow,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.managerViewer.id,
        roles.managerEditor.id
      ]
    }
  }
];



// WEBPACK FOOTER //
// ./src/entities/field-manager/field-manager-routes.js